// extracted by mini-css-extract-plugin
module.exports = {"bulletsContainer":"yLuZ98UXTT+PqS94nuxKYA==","bulletsContent":"PqnP+OyhCTv-6Rj3IKU-Vg=="};